<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            v-if="abilities.can('create', 'campaigns')"
            icon="add"
            @click="addCampaign"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>

      



      <DataGrid :context="'SelectedFieldsofCampaigns'" 
      @updateCommentsToHistoricNotes="updateCommentsToHistoricNotes"
            @importGrade3ContctsToGrade3RebuildTable="importGrade3ContctsToGrade3RebuildTable"
      :rowSelection="'single'"
     ref="campaigns"
     :columnDefs="campaignsColumnDefs"
     :rowData="campaignsRecords"
     :dataSource="campaignsDataSource"
     @showCampaignSelectedFields="showCampaignSelectedFields"
     @openHTMLDashboardForAdmin="openHTMLDashboardForAdmin"
   >
   </DataGrid>

 
    </vx-card>

      <vs-popup fullscreen title="Dashboard" :active.sync="showHideHTMLDashboard">


      <div v-if="sdMeta.updatedAt" class="flex items-center flex-wrap mb-2">
        <span class="text-sm">Last updated {{ formatUtc(sdMeta.updatedAt) }} · all times UTC</span>
        <vs-button
          v-if="sdMeta.refreshable"
          size="small"
          type="border"
          icon="refresh"
          class="ml-3"
          :disabled="sdMeta.refreshing"
          @click="refreshSdDashboard"
        >{{ sdMeta.refreshing ? "Refreshing…" : "Refresh" }}</vs-button>
        <span v-if="sdMeta.note" class="text-sm ml-3">{{ sdMeta.note }}</span>
      </div>
      <iframe :src="dashboardBlobUrl" sandbox="allow-scripts allow-popups" style="width:100%;height:1400px;border:none"></iframe>



    </vs-popup>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
export default {
  data: () => ({
      dashboardBlobCache: {},  // ADD THIS
    dashboardHtmlCache: {},   // campaignId -> the SD template HTML, to rebuild after a refresh
    dashboardMetaCache: {},   // campaignId -> { updatedAt, refreshable } for the header line
    sdMeta: { campaignId: null, updatedAt: null, refreshable: false, refreshing: false, note: "" },
    sdDestroyed: false,
    dashboardBlobUrl: '',
    showHideHTMLDashboard: false,
    campaignsRecords: [],
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 180
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,

        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        flex: 1,

        field: "end_date",
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Status",
        flex: 1,

        field: "campaign_status",
        flex: 1,  
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    user_id: null,
    user_role: null,
    abilities: null,

    selected_client_id: null,
    companySearchComponentKey: 0,
    selected: [],
    selected_campaign_status: "All",
    log: [],
    campaigns: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    campaignStatusList: [],
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    CampaignAutocomplete,
    "v-select": vSelect,
    moduleCampaignManagement,
    ClientAutocomplete,
    DataGrid
  },
  watch: {
     beforeDestroy() {
  this.sdDestroyed = true;
  Object.values(this.dashboardBlobCache).forEach(url => URL.revokeObjectURL(url));
},
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
    selected_campaign_status: function(val) {
      if (val != "All") this.fetchCampaignWithFilter();
    }
  },
  methods: {
    emptySdMeta(campaignId) {
      return { campaignId: campaignId, updatedAt: null, refreshable: false, refreshing: false, note: "" };
    },
    showSdSnapshot(campaignId, snapshot) {
      // The dashboard gets exactly what it got before: { payload, updated_at, viewer_user_id }.
      const injected = { payload: snapshot.payload, updated_at: snapshot.updated_at, viewer_user_id: snapshot.viewer_user_id };
      const json   = JSON.stringify(injected).replace(/</g, '\\u003c');
      const sOpen  = '<' + 'script>';
      const sClose = '<' + '/' + 'script>';
      const inject = sOpen + 'window.__SD_SNAPSHOT__ = ' + json + ';' + sClose;
      const html = (this.dashboardHtmlCache[campaignId] || '').replace('</head>', inject + '</head>');
      const blobUrl = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
      if (this.dashboardBlobCache[campaignId]) URL.revokeObjectURL(this.dashboardBlobCache[campaignId]);
      this.dashboardBlobCache[campaignId] = blobUrl;
      this.dashboardBlobUrl = blobUrl;
      const meta = this.emptySdMeta(campaignId);
      meta.updatedAt = snapshot.updated_at || null;
      // Refresh only when the figures came from emp-dash and the dashboard is not final.
      meta.refreshable = snapshot.source === "emp-dash" && snapshot.refreshable === true;
      this.dashboardMetaCache[campaignId] = { updatedAt: meta.updatedAt, refreshable: meta.refreshable };
      this.sdMeta = Object.assign({}, this.dashboardMetaCache[campaignId], { campaignId: campaignId, refreshing: false, note: "" });
    },
    async refreshSdDashboard() {
      if (this.sdMeta.refreshing) return;
      const campaignId = this.sdMeta.campaignId;
      const before = this.sdMeta.updatedAt;
      const token = localStorage.getItem("accessToken");
      const base  = this.$base_url + '/api/campaigns';
      this.sdMeta.refreshing = true;
      this.sdMeta.note = "Refreshing… this usually takes under a minute.";
      let res = null;
      try {
        res = await fetch(`${base}/sd-dashboard-refresh/${campaignId}`, { method: 'POST', headers: { Authorization: token } });
      } catch (e) { res = null; }
      if (!res || res.status !== 202) {
        if (res && res.status === 409) {
          this.sdMeta.refreshable = false;
          this.dashboardMetaCache[campaignId].refreshable = false;
          this.sdMeta.note = "This dashboard is final and is not refreshed.";
        } else {
          this.sdMeta.note = "Refresh is temporarily unavailable. The figures shown are unchanged.";
        }
        this.sdMeta.refreshing = false;
        return;
      }
      // Refresh (emp-dash only): normally lands in under 35 s; can legitimately never
      // land (emp-dash keeps the previous figures), so give up after 60 s and say so.
      const started = Date.now();
      while (!this.sdDestroyed && this.sdMeta.campaignId === campaignId && Date.now() - started <= 60000) {
        await new Promise(r => setTimeout(r, 5000));
        if (this.sdDestroyed || this.sdMeta.campaignId !== campaignId) return;
        try {
          const d = await fetch(`${base}/sd-dashboard-data/${campaignId}`, { headers: { Authorization: token } });
          if (d.ok) {
            const snap = await d.json();
            if (snap.updated_at && snap.updated_at !== before) {
              this.showSdSnapshot(campaignId, snap);
              this.sdMeta.note = "Updated.";
              return;
            }
          }
        } catch (e) { /* a failed poll keeps the current figures and keeps waiting */ }
      }
      if (this.sdMeta.campaignId === campaignId) {
        this.sdMeta.refreshing = false;
        this.sdMeta.note = "No newer figures yet. Still showing the figures from " + this.formatUtc(before) + ".";
      }
    },
    formatUtc(iso) {
      if (!iso) return "";
      const t = new Date(iso);
      if (isNaN(t.getTime())) return iso;
      return t.toISOString().slice(0, 16).replace("T", " ") + " UTC";
    },
     async openHTMLDashboardForAdmin(data) {
      try {
  const campaignId = data.campaign_id;
  if (this.dashboardBlobCache[campaignId]) {
    this.dashboardBlobUrl = this.dashboardBlobCache[campaignId];
    this.sdMeta = Object.assign({}, this.dashboardMetaCache[campaignId] || this.emptySdMeta(campaignId));
    this.showHideHTMLDashboard = true;
    return;
  }
 
  const token = localStorage.getItem("accessToken");
  const base  = this.$base_url + '/api/campaigns';
 
  // Fetch HTML and snapshot in parallel — BOTH carry the auth token.
  const [htmlRes, dataRes] = await Promise.all([
    fetch(`${base}/sd-dashboard/${campaignId}`,      { headers: { Authorization: token } }),
    fetch(`${base}/sd-dashboard-data/${campaignId}`, { headers: { Authorization: token } })
  ]);
  if (!htmlRes.ok) throw new Error(`HTTP ${htmlRes.status} (html)`);
  if (!dataRes.ok) throw new Error(`HTTP ${dataRes.status} (data)`);




const html = await htmlRes.text();
const snapshot = await dataRes.json();   // ONE object: { payload, updated_at, viewer_user_id } (+ source, refreshable from emp-dash)
this.dashboardHtmlCache[campaignId] = html;
this.showSdSnapshot(campaignId, snapshot);
this.showHideHTMLDashboard = true;



} catch (err) {
  console.error("Failed to load HTML dashboard:", err);
  this.$vs.notify({ title: 'Dashboard', text: 'This dashboard is temporarily unavailable. Please try again shortly.', color: 'danger' });
}
  
},
    updateCommentsToHistoricNotes(data) {
      let self = this;
            self.$vs.loading();

      console.log("updateCommentsToHistoricNotes", data);
        self.$store.dispatch("campaignsManagement/updateCommentsToHistoricNotes", data)
          .then((response) => {
            let response_data = response.data;
            if (response_data.status === "success") {
              self.$vs.notify({
                color: "success",
                title: "Comments Updated",
                text: "The comments were successfully updated to historic notes."
              });
            } else {
              self.$vs.notify({
                color: "danger",
                title: "Update Failed",
                text: response_data.message || "Failed to update comments."
              });
            }

                      self.$vs.loading.close();

            self.$router.go()

         



          // if re
            // console.log("Response from updateCommentsToHistoricNotes:", response);
            // console.log("Comments updated successfully");
          })
          .catch(err => {
            console.error("Error updating comments:", err);
          });
    },
    importGrade3ContctsToGrade3RebuildTable(data) {
      let self = this;
            self.$vs.loading();

      console.log("importGrade3ContctsToGrade3RebuildTable", data);
        self.$store.dispatch("campaignsManagement/importGrade3ContctsToGrade3RebuildTable", data)
          .then((response) => {
            let response_data = response.data;
            if (response_data.status === "success") {
              self.$vs.notify({
                color: "success",
                title: "Import Successful",
                text: "The Grade 3 contacts were successfully imported to the Grade 3 rebuild table."
              });
            } else {
              self.$vs.notify({
                color: "danger",
                title: "Import Failed",
                text: response_data.message || "Failed to import Grade 3 contacts."
              });
            }

                      self.$vs.loading.close();

            self.$router.go()

         



          // if re
            // console.log("Response from updateCommentsToHistoricNotes:", response);
            // console.log("Comments updated successfully");
          })
          .catch(err => {
            console.error("Error updating comments:", err);
          });
    },
    showCampaignSelectedFields(value) {
   
    },
    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignsForGridForSelectedFields",
              params.request
            )
            .then(function(response) {

              console.log("Campaigns", response);


              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.campaigns.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.campaigns.gridApi.showNoRowsOverlay();
                params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    resetAll() {
      this.selected_campaign_status = "All";
      this.resetCampaign();
    },
    resetCampaign() {
          if (this.user_role == "Sales Developer") {
      this.fetchSalesDeveloperAssociatedCampaigns();
    } else {
      this.fetchCampaigns();
    }
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
                if (this.user_role == "Sales Developer") {
      this.fetchSalesDeveloperAssociatedCampaigns();
    } else {
      this.fetchCampaigns();
    }
    },
    showAssociatedCampaign() {
      let selected_client = moduleClientManagement.state.clients.datas;
      this.selected_client_id = selected_client[0].id;
      this.fetchCampaignsAsClient(selected_client[0].id);
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCampaignWithFilter() {
      let filter = {};
      filter.status = this.selected_campaign_status;
      filter.client_id = this.selected_client_id;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaignsWithFilter", filter)
        .then(res => {
          this.campaigns = res.data;
          let self = this;
          self.campaigns = self.campaigns.filter(function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }

            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            return ele;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getCampaignStatus() {
      this.$store
        .dispatch("campaignsManagement/getCampaignStatus")
        .then(res => {
          this.campaignStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    async showStatusName(statusId) {
      let result = await this.$store
        .dispatch("campaignsManagement/fetchStatus", statusId)
        .then(res => {
          return res;
        })
        .catch(err => {
          console.log(err);
        });

      return result;
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name: data[property].campaign_name + '  -   ' +  data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addCampaign() {
      this.$router.push({ path: "/campaign/add" });
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    },
    viewAccount(id) {
      this.$router.replace("/campaign/" + id);
    },
    editAccount(id) {
      this.$router.replace("/campaign/edit/" + id);
    },
    handleChildEvent() {
      this.searchedclients = moduleClientManagement.state.searched_clients;
      console.log(this.searchedclients);

      let self = this;
      if (typeof this.searchedclients.id != "undefined") {
        let selected_client = moduleClientManagement.state.searched_clients;
        this.fetchCampaignsAsClient(selected_client.id);
      } else {
        self.campaigns = moduleCampaignManagement.state.campaign.datas.filter(
          function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }
            return ele;
          }
        );
      }
    },
    confirmDeleteAccount(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        text: `Are you sure you want to delete this campaign?`,
        title: `Delete Campaign`,
        accept: this.deleteAccount,
        acceptText: "Delete"
      });
    },
    deleteAccount() {
      this.$store
        .dispatch("campaignsManagement/removeCampaign", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchCampaigns();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Campaign Deleted",
        text: "The Campaign was successfully deleted"
      });
    },
    fetchCampaigns() {
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaigns", this.paginationAttr)
        .then(res => {
          let self = this;
          self.campaigns = moduleCampaignManagement.state.campaign.datas.filter(
            function(ele) {
              if (ele.campaign_status) {
                self.showStatusName(ele.campaign_status).then(function(data) {
                  if (data) {
                    ele.campaign_status = data.data.campaign_status;
                  }
                });
              } else {
                ele.campaign_status = null;
              }

              if (ele.client_id) {
                //get promise value
                self.showClientName(ele.client_id).then(function(data) {
                  if (data) {
                    ele.client_id = data.data.company_name;
                  }
                });
              } else {
                ele.client_id = null;
              }
              return ele;
            }
          );
          this.total = moduleCampaignManagement.state.campaign.total;
          this.per_page = moduleCampaignManagement.state.campaign.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchSalesDeveloperAssociatedCampaigns() {
      this.paginationAttr.sales_developer_id = this.user_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchSalesDeveloperAssociatedCampaigns",
          this.paginationAttr
        )
        .then(res => {
          let self = this;
          console.log("sales developer", res);
          self.campaigns = moduleCampaignManagement.state.campaign.datas.filter(
            function(ele) {
              if (ele.campaign_status) {
                self.showStatusName(ele.campaign_status).then(function(data) {
                  if (data) {
                    ele.campaign_status = data.data.campaign_status;
                  }
                });
              } else {
                ele.campaign_status = null;
              }

              if (ele.client_id) {
                //get promise value
                self.showClientName(ele.client_id).then(function(data) {
                  if (data) {
                    ele.client_id = data.data.company_name;
                  }
                });
              } else {
                ele.client_id = null;
              }
              return ele;
            }
          );
          this.total = moduleCampaignManagement.state.campaign.total;
          this.per_page = moduleCampaignManagement.state.campaign.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    async showClientName(clientId) {
      let result = await this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          return res;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });

      return result;
    },
        updateSteps(campaignId){
      this.$router.push({ path: `/campaigns/steps-dependency/` + campaignId });
    },
    editSteps(campaignId){
      this.$router.push({ path: `/campaigns/edit-campaign-step/` + campaignId });
    },
    fetchCampaignsAsClient(clientId) {
      let filter = {};
      filter.client_id = clientId;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchAllCampaignsAsClient", filter)
        .then(res => {
          let self = this;
          console.log(res.data);
          self.campaigns = res.data.filter(function(ele) {
            if (ele.campaign_status) {
              self.showStatusName(ele.campaign_status).then(function(data) {
                if (data) {
                  ele.campaign_status = data.data.campaign_status;
                }
              });
            } else {
              ele.campaign_status = null;
            }

            if (ele.client_id) {
              //get promise value
              self.showClientName(ele.client_id).then(function(data) {
                if (data) {
                  ele.client_id = data.data.company_name;
                }
              });
            } else {
              ele.client_id = null;
            }
            return ele;
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() {
    if (this.user_role == "Sales Developer") {
      this.fetchSalesDeveloperAssociatedCampaigns();
    } else {
      this.fetchCampaigns();
    }
    this.getCampaignStatus();
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
.filter {
  width: 300px;
}
.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
